import { render, staticRenderFns } from "./changeMajor.vue?vue&type=template&id=29e02058&scoped=true"
import script from "./changeMajor.vue?vue&type=script&lang=js"
export * from "./changeMajor.vue?vue&type=script&lang=js"
import style0 from "./changeMajor.vue?vue&type=style&index=0&id=29e02058&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e02058",
  null
  
)

export default component.exports